import { Authority } from "./authorities"

export class UserBackend {
    authenticated: boolean;
    authorities: Authority[];
    credentials: any;
    details: any;
    email: string;
    name: string;
    principal: string;
    storeIds: number[] = [];

    
}